import type React from "react";
import { useState } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button,
	List,
	ListItem,
	ListItemText,
	CircularProgress,
} from "@mui/material";
import { useWorkOrderModalsContext } from "@/shared/work-orders-modals/context/work-order-modals.context";
import { addLinkAssetDocument } from "@/pages/asset-details/repositories/AssetDetailsRepositorie";

type Props = {
	show: boolean;
	onHide: (shouldUpdate: boolean) => void;
	AssetId: number | string;
	searchAssetResources?: Function;
	WorkOrderName: string;
	AssetName: string;
};

export const AssetAddDrawingsDialog: React.FC<Props> = ({
	show,
	onHide,
	AssetId,
	searchAssetResources,
	WorkOrderName,
	AssetName,
}) => {
	const {
		state: { workOrderDrawingToAdd },
	} = useWorkOrderModalsContext();
	const [isAdding, setIsAdding] = useState(false);

	const addResourcesToAsset = async () => {
		setIsAdding(true);
		let allSuccessful = true;

		for (const drawing of workOrderDrawingToAdd) {
			const res = await addLinkAssetDocument(AssetId, drawing.DocumentName, "");
			if (!res.ok) {
				allSuccessful = false;
			}
		}

		setIsAdding(false);
		if (searchAssetResources) searchAssetResources();
		onHide(allSuccessful);
	};

	return (
		<Dialog open={show} aria-labelledby="responsive-dialog-title">
			<DialogTitle style={{ paddingBottom: 6 }} id="responsive-dialog-title">
				{workOrderDrawingToAdd?.length > 1
					? `Add drawings to Asset: ${AssetName}`
					: `Add drawing to Asset: ${AssetName}`}
			</DialogTitle>
			<DialogContent>
				<DialogContentText>
					The following drawings have been added to the work order{" "}
					{WorkOrderName}. Would you like to add them to the corresponding asset
					as well?
				</DialogContentText>
				<List>
					{workOrderDrawingToAdd.map((drawing: any, index: number) => (
						<ListItem key={index}>
							<ListItemText primary={drawing?.Title} />
							{}
						</ListItem>
					))}
				</List>
			</DialogContent>
			<DialogActions style={{ padding: "24px" }}>
				<Button
					variant="contained"
					fullWidth
					color="inherit"
					onClick={() => onHide(false)}
					disabled={isAdding}
				>
					SKIP
				</Button>
				<Button
					fullWidth
					variant="contained"
					onClick={addResourcesToAsset}
					color="primary"
					autoFocus
					disabled={isAdding}
				>
					{isAdding ? <CircularProgress size={24} /> : "ADD"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
